import api from "../../config/api";
import { handleApiError } from "@/utils/ErrorHandler";

const state = {
    workgroupAdmins: [],
    loading: false,
    error: null,
    saving: false,
};

const mutations = {
    SET_WORKGROUP_ADMINS(state, data) {
        state.workgroupAdmins = data;
    },
    SET_LOADING(state, value) {
        state.loading = value;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
    SET_SAVING(state, value) {
        state.saving = value;
    },
};

const actions = {
    async fetchWorkgroupAdmins({ commit }, workgroupId) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);
        try {
            const response = await api.get(`/activity-workgroups/${workgroupId}/admins`);
            const data = response.data?.data || [];
            commit("SET_WORKGROUP_ADMINS", data);
            return data;
        } catch (error) {
            const message = handleApiError(error, "Failed to fetch workgroup admins");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_LOADING", false);
        }
    },

    async saveWorkgroupAdmins({ commit }, { workgroupId, personIds }) {
        commit("SET_SAVING", true);
        commit("SET_ERROR", null);
        try {
            const response = await api.post(`/activity-workgroups/${workgroupId}/admins`, {
                person_ids: personIds,
            });
            return response.data;
        } catch (error) {
            const message = handleApiError(error, "Failed to save workgroup admins");
            commit("SET_ERROR", message);
            throw new Error(message);
        } finally {
            commit("SET_SAVING", false);
        }
    },
};

const getters = {
    workgroupAdmins: (state) => state.workgroupAdmins,
    workgroupAdminsLoading: (state) => state.loading,
    workgroupAdminsError: (state) => state.error,
    workgroupAdminsSaving: (state) => state.saving,
};

export default {
    state,
    mutations,
    actions,
    getters,
};
